/* eslint-disable */
export const isFrontendFunctionalityDisabled = (time: number) =>
  process.env.REACT_APP_ENVIRONMENT === 'production' &&
  Date.now() < Date.UTC(2021, 11, 16, 12);

export const FUNCTIONALITY_ENABLES_AT = Date.UTC(2021, 11, 16, 12);
